import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { addDays } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import { StorePageHeaderName } from "../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import { user_requisition } from "../../api/requisition";
import { toast } from "react-toastify";
import Dashboard from "./dashboard";

const PurchaseManagerDashboard = () => {



    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Dashboard'))

  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    total: 0,
    approved: 0,
    pending: 0
  })
  document.title = "Purchase Dashboard";
  const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },]
  const handleProductNameClick = (isOpen) => {
    setOpen(isOpen)
  };
  const [showList, setShowList] = useState(false);

  const toggleList = () => {
    setShowList(!showList);
  };

  const columns = [
    { field: 'Sl_No', resizable: false, headerName: (<div><Checkbox /><span>SL.No</span></div>),
    renderCell: (params) => {
      return <div><Checkbox /><span>1</span></div>;
  }, 
    width: 100,
    sortable: false, 
  },
    {
      field: 'Requisition_No',
      headerName: 'Requisition No',
      headerClassName: 'table-header-background',
      // width: 160,
      editable: true,
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: 'Product_Name',
      headerName: 'Product Name',
      headerClassName: 'table-header-background',
      width: 200,
      editable: true,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const productName = params.value;
        return (
          <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
            {productName}
          </div>
        );
      },
    },
    {
      field: 'Total_Qty',
      headerName: 'Quantity',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 160,
    },
    {
      field: 'approved',
      headerName: 'Approved',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
    //   width: 160,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
    },
    {
      field: 'remaining',
      headerName: 'Remaining',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
    //   width: 160,
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    flex: 1,
    },
    {
      field: 'value',
      headerName: 'Value',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 160,
    },
    {
      field: 'mop',
      headerName: 'FOB',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 160,
    },
   
    {
      field: 'Status',
      headerName: 'Status',
      headerClassName: 'table-header-background',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      width: 160,
      renderCell: (params) => {
        const status = params.value;
        // Define the color for the chip based on the status
        let chipColor = 'default';
        if (status == 'Waiting for response') {
          chipColor = 'error'; // Red color for waiting for response
        } else if (status == 'approved') {
          chipColor = 'success'; // Green color for approved
        }

        // Render the Chip component with the outlined variant and appropriate color
        return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
      },
    },
  ];

  const rows = [
    { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2,approved: 10, remaining: 0, value: 200789, mop: 800970, Status: 'Waiting for response' },
    { id: 2, Sl_No: 1, Requisition_No: 'REQ2', Product_Name: 'HOBS HB-MARICA',  Total_Qty: 2,approved: 10, remaining: 0, value: 200789, mop: 800970, Status: 'approved' },
  ];
  const approvalcolumns = [
    { field: 'Sl_No', headerName: 'Sl.No', 
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    resizable: false,
    sortable: false,
    },

    {
        field: 'Product_Name',
        headerName: 'Product Name',
        headerClassName: 'table-header-background',
        width: 200,
        resizable: false,
        sortable: false,
        renderCell: (params) => {
            const productName = params.value;
            return (
                <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
                    {productName}
                </div>
            );
        },
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'dP_Value',
      headerName: 'DP Value',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'MOP',
      headerName: 'FOB',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'vendor_name',
      headerName: 'Vendor Name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      // width: 160,
  },
  {
      field: 'payment_term',
      headerName: 'Payment Term',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'actual_date',
      headerName: 'Actual Date',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,

  },
  {
    field: 'PO_no',
    headerName: 'PO No.',
    description: 'This column has a value getter and is not sortable.',
    sortable: false,
    resizable: false,
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    // width: 160,

},
    {
        field: 'Status',
        headerName: 'Status',
        headerClassName: 'table-header-background',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        resizable: false,
        renderCell: (params) => {
            const status = params.value;
            // Define the color for the chip based on the status
            let chipColor = 'default';
            if (status == 'Waiting for response') {
                chipColor = 'error'; // Red color for waiting for response
            } else if (status == 'approved') {
                chipColor = 'success'; // Green color for approved
            }

            // Render the Chip component with the outlined variant and appropriate color
            return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
        },
    },
];

const approvalrows = [
    { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-',PO_no:'PO1234', Status: 'Waiting for response' },
    { id: 2, Sl_No: 2, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-', PO_no:'PO1234', Status: 'Waiting for response' },
];
  const dateRangeData = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    }
  ]
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };

  const fetchRequisitionHistory = async (payload = {}) => {
    try {
      setIsLoading(true)
      let count = 0; // Initialize the count variable outside the map function
      const response = await user_requisition(payload);

    
      if(response.statusCode ===200 && response.data.getRequisition.length >0){
        
        let results = response.data.getRequisition.flatMap(requisition => requisition.procurementRequisitionItem.map(item => ({
          id: item.id,
          Sl_No: ++count,
          Requisition_No: requisition.requisition_number,
          Requisition_Date:requisition.requisition_date,
          Product_Name: item.item_name,
          Total_Qty: item.total_qty,
          approved: item.approved_qty,
          remaining: item.total_qty - item.approved_qty,
          Value: item.value,
          Allocation_QTY: item.allocation_qty,
          // Actual_Date: '--',
          // Modified_Date:'--',
          Arival_Date: '--',
          Status: item.status
        })));
       setData({
        total: results.length,
        approved: results.filter(el => el.Status == 'COMPLETE_APPROVED' || el.Status == 'PARTIALLY_APPROVED' || el.Status == 'EXCESS_APPROVED' || el.Status == 'APPROVED').length,
        pending: results.filter(el => el.Status == 'APPROVAL_PENDING' || el.Status == 'SAVED' || el.Status == 'REJECTED').length

       })
      }
      

    } catch (error) {
      console.error('Error fetching requisition history:', error);
      toast.error('Something went wrong')
      // Handle error
    }
    finally {
      setIsLoading(false); // Reset loading state after operation completes
    }
  };

  useEffect(() => {
    fetchRequisitionHistory();
  }, []);

  return (
    <React.Fragment>

      <div className="page-content">
        <Container fluid>
          {/* <div>
            <h4 className="mb-3 requisition_text">Approval Requisitions</h4>
          </div> */}
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '17px' }}>
            <Card className='mb-3 number_requisition'
            >
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <LibraryAddIcon />
                    <span style={{ marginLeft: '8px', color:'white', fontSize:'22px',fontWeight:'600' }}>{data.total}</span>
                  </div>
                </CardTitle>
                <CardText>
                  <div><p>Total Number of Requisitions</p></div>
                </CardText>
              </CardBody>
            </Card>
            <Card className='mb-3 approved_requisition_card'>
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <b> <DoneAllIcon /></b>
                    <span style={{marginLeft: '8px', color:'white', fontSize:'22px',fontWeight:'600'}}>{data.approved}</span>
                  </div>
                </CardTitle>
                <CardText>
                  <div><p>Approved Requisitions </p></div>
                </CardText>
              </CardBody>
            </Card>
            <Card className='mb-3 notapproved_requisition_card'
            >
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    {/* <span><CloseIcon /></span> */}
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 22v-2H5V4h10v4h4v5h2V7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992zm9.536-.879L19.414 19l2.122-2.121l-1.415-1.415l-2.12 2.122l-2.122-2.122l-1.414 1.415l2.12 2.12l-2.12 2.122l1.414 1.414L18 20.415l2.121 2.12z"/></svg></span>
                    <span style={{ marginLeft: '8px', color:'white', fontSize:'22px',fontWeight:'600' }}>{data.pending}</span>
                  </div>
                </CardTitle>
                <CardText>
                  <div><p>Not Approved Requisition</p></div>
                </CardText>
              </CardBody>
            </Card>
          </div>

          <Dashboard/>
        </Container>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="datepicker_modal modal_box"
      >
        <ModalBody className='pt-2'>
          <div>
            <DateRangePicker
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              editableDateInputs={true}
              ranges={dateRangeData}
              direction="horizontal"
              className="w-100 datepicker_customise"
              rangeColors={['#0060AA']}
            />
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseManagerDashboard;
